module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.d3b069b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_hero_768.png
// module id = CqH4
// module chunks = 0